export const colours = {
  tumbleweed: "#D1A58C",
  gainsboro: "#E0E0E0",
  brownSugar: "#A06340",
  cultured: "#F2F2F2",
  jet: "#333333",
};
